<div #queriesParent style="overflow: visible; height: 100%" >
  <div *ngIf="report.runStatus === ReportStatus.Created;else queued">
    <div *ngIf="!reportQueryDataSource || reportQueryDataSource.length === 0;else queries" style="font:13px;">
      Add search terms
    </div>
    <ng-template #queries>
      <mat-list style="display: flex; flex-direction: column; gap: 16px; width: 100%">
        <mat-list-item *ngFor="let query of reportQueryDataSource" class="no-hover" style="padding: 0; height: 100%;"
          (mouseenter)="editReportQueryId = query.searchReportQueryId" (mouseleave)="editReportQueryId = null">
          <div style="display: flex; align-items:center; width:100%">
            <mat-form-field class="show-no-errors" style="flex: auto;">
              <input matInput (focus)="editReportQueryId = query.searchReportQueryId" (blur)="updateReportQuery(query)" (keyup.enter)="updateReportQuery(query)" [(ngModel)]="query.query">
            </mat-form-field>
            <div style="min-width: 40px; margin-left:10px;">
              @if (editReportQueryId === query.searchReportQueryId) {
                <button mat-icon-button (click)="deleteReportQuery(query.searchReportQueryId)">
                  <mat-icon>clear</mat-icon>
                </button>              
              }
              @else {
                <!--placeholder for sizing-->
                <button mat-icon-button [disabled] style="opacity: 0;">
                  <mat-icon>clear</mat-icon>
                </button>   
              }
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </ng-template>
  </div>
  <ng-template #queued>
    <div *ngIf="report.runStatus === ReportStatus.Running;else show_results" style="font:13px;">
      Report is processing
    </div>
    <ng-template #show_results>
      <!-- Choose whichever height is greater: parent or graph. This means the the graph will stretch to fill available space if shorter than parent, but not shrink to an unreadable size if larger (graphHeight is effectively a min height here). -->
      <div *ngIf="isGraphView; else show_data" [style.height.px]="queriesParent.offsetHeight > graphHeight ? queriesParent.offsetHeight : graphHeight">
        <ngx-charts-bar-horizontal-2d [results]="groups" [xAxis]="true" [showXAxisLabel]="true" [xAxisLabel]="'Hits'" [yAxis]="true" [showYAxisLabel]="true" [yAxisLabel]="'Search Term'" [legend]="true" (select)="select($event)">

        </ngx-charts-bar-horizontal-2d>
      </div>

      <ng-template #show_data>
        <table mat-table [dataSource]="reportQueryDataSource" class="mat-elevation-z4 padding-preset-1" style="overflow: auto; width: 100%">

          <ng-container matColumnDef="query">
            <th mat-header-cell *matHeaderCellDef> Search Term </th>
            <td mat-cell *matCellDef="let element">
              <a [routerLink]="['/review/search']" [queryParams]="{ SearchReportId: element.searchReportId, SearchReportQueryIds: element.searchReportQueryId, IsSearch: true }">{{element.query}}</a>
            </td>
          </ng-container>

          <ng-container matColumnDef="hitCount">
            <th mat-header-cell *matHeaderCellDef style="width: 100px; text-align: right;"> Hit Count </th>
            <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.hitCount}} </td>
          </ng-container>

          <ng-container matColumnDef="expandedHitCount">
            <th mat-header-cell *matHeaderCellDef style="width: 115px; text-align: right;"> Expanded Hit Count </th>
            <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.expandedHitCount}} </td>
          </ng-container>

          <ng-container matColumnDef="uniqueHitCount">
            <th mat-header-cell *matHeaderCellDef style="width: 115px; text-align: right; padding-right: 24px;"> Unique Hit Count </th>
            <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.uniqueHitCount}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        </table>
      </ng-template>
    </ng-template>
  </ng-template>
</div>
